/* DOGSHIT — procedural, interactive product study. Requires THREE r160. */
(function () {
  'use strict';

  if (window.__dogshit3dRuntime) { window.__dogshit3dRuntime.scan(document); return; }

  const INSTANCES = new Map();
  const PALETTE = { olive: '#556644', sunny: '#FFD84D', terracotta: '#E07A5F', sky: '#B7D7F0', cream: '#EFE9DD' };
  const NAMES = { olive: 'Olive', sunny: 'Sunny', terracotta: 'Terracotta', sky: 'Sky', cream: 'Cream' };
  const clamp = (n, a, b) => Math.min(b, Math.max(a, n));

  function init(host) {
    if (INSTANCES.has(host)) return;
    const T = window.THREE;
    const status = document.getElementById('scene-status');
    const setStatus = text => { if (status) status.textContent = text; };
    if (!T) { host.dataset.state = 'fallback'; setStatus('Náhled kolekce. 3D není v tomto prohlížeči dostupné.'); return; }

    const scope = host.closest('[data-dogshit-landing], .shopify-section') || document;
    const resources = new Set();
    const cleanup = [];
    const keep = object => { resources.add(object); return object; };
    const on = (target, name, fn, options) => { target.addEventListener(name, fn, options); cleanup.push(() => target.removeEventListener(name, fn, options)); };
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let reduced = motionQuery.matches;
    let renderer;
    try {
      renderer = new T.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'low-power' });
    } catch (_) {
      host.dataset.state = 'fallback';
      setStatus('Náhled kolekce. 3D není v tomto prohlížeči dostupné.');
      return;
    }

    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, window.innerWidth < 768 ? 1.6 : 2));
    renderer.outputColorSpace = T.SRGBColorSpace;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.28;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = T.PCFSoftShadowMap;
    renderer.setClearColor(0x000000, 0);
    const canvas = renderer.domElement;
    canvas.className = 'dogshit-3d-canvas';
    canvas.tabIndex = 0;
    canvas.setAttribute('role', 'img');
    canvas.setAttribute('aria-label', 'Interaktivní 3D návrh obojku DOGSHIT. Tažením nebo šipkami vlevo a vpravo ho otočíte.');
    canvas.style.cssText = 'display:block;width:100%;height:100%;touch-action:pan-y;cursor:grab;outline-offset:-5px;';
    host.appendChild(canvas);
    const scene = new T.Scene();
    const camera = new T.PerspectiveCamera(37, 1, 0.1, 35);
    const world = new T.Group();
    const collar = new T.Group();
    world.add(collar);
    scene.add(world);

    // A tiny generated studio environment creates broad reflections on the hardware.
    const environmentFaces = [];
    for (let i = 0; i < 6; i++) {
      const face = document.createElement('canvas');
      face.width = face.height = 128;
      const c = face.getContext('2d');
      const g = c.createLinearGradient(0, 0, 128, 128);
      g.addColorStop(0, ['#fffdf7', '#a79b84', '#fffdf7', '#8f866e', '#e5e0cc', '#e7ddc5'][i]);
      g.addColorStop(0.45, '#fffdf7');
      g.addColorStop(0.67, '#e3d9c2');
      g.addColorStop(1, i % 2 ? '#625646' : '#d3c8b0');
      c.fillStyle = g; c.fillRect(0, 0, 128, 128);
      if (i !== 3) { c.fillStyle = 'rgba(255,255,255,.85)'; c.fillRect(38, 0, 22, 128); }
      environmentFaces.push(face);
    }
    const env = keep(new T.CubeTexture(environmentFaces));
    env.colorSpace = T.SRGBColorSpace;
    env.needsUpdate = true;
    scene.environment = env;

    scene.add(new T.HemisphereLight(0xfffdf4, 0x77684c, 2.2));
    const key = new T.DirectionalLight(0xfff7e4, 4.0);
    key.position.set(-3.3, 6, 5);
    key.castShadow = true;
    key.shadow.mapSize.set(1024, 1024);
    key.shadow.camera.left = key.shadow.camera.bottom = -3.5;
    key.shadow.camera.right = key.shadow.camera.top = 3.5;
    key.shadow.camera.near = 0.1; key.shadow.camera.far = 15;
    key.shadow.bias = -0.0004;
    key.shadow.normalBias = 0.018;
    key.shadow.radius = 4;
    scene.add(key);
    const rim = new T.DirectionalLight(0xf8f5ce, 2.0);
    rim.position.set(4, 3, -4);
    scene.add(rim);
    const fill = new T.DirectionalLight(0xdceaf2, 0.75);
    fill.position.set(4, 0, 3); scene.add(fill);

    // Woven cotton: a small deterministic texture, with relief rather than a flat photograph.
    const weaveCanvas = document.createElement('canvas');
    weaveCanvas.width = weaveCanvas.height = 128;
    const wc = weaveCanvas.getContext('2d');
    wc.fillStyle = '#dfdfdf'; wc.fillRect(0, 0, 128, 128);
    for (let y = 0; y < 128; y += 4) {
      for (let x = 0; x < 128; x += 4) {
        const vertical = ((x / 4 + y / 4) % 2) === 0;
        wc.fillStyle = vertical ? '#fafafa' : '#c1c1c1';
        wc.fillRect(x + (vertical ? 1 : 0), y + (vertical ? 0 : 1), vertical ? 2 : 4, vertical ? 4 : 2);
        wc.fillStyle = 'rgba(255,255,255,.19)'; wc.fillRect(x + 1, y + 1, 1, 2);
      }
    }
    const weave = keep(new T.CanvasTexture(weaveCanvas));
    weave.wrapS = weave.wrapT = T.RepeatWrapping;
    weave.repeat.set(10, 1.1);
    weave.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
    weave.colorSpace = T.SRGBColorSpace;
    const bump = keep(new T.CanvasTexture(weaveCanvas));
    bump.wrapS = bump.wrapT = T.RepeatWrapping;
    bump.repeat.copy(weave.repeat);
    bump.anisotropy = weave.anisotropy;
    const cotton = keep(new T.MeshStandardMaterial({ color: PALETTE.olive, roughness: 0.9, metalness: 0.0, map: weave, bumpMap: bump, bumpScale: 0.017, envMapIntensity: 0.28 }));
    const inside = keep(cotton.clone()); inside.color.multiplyScalar(0.72); inside.bumpScale = 0.012;
    const edge = keep(new T.MeshStandardMaterial({ color: PALETTE.olive, roughness: 0.96 }));
    const thread = keep(new T.MeshStandardMaterial({ color: '#81926a', roughness: 1 }));
    const metal = keep(new T.MeshStandardMaterial({ color: '#6a6759', metalness: 0.92, roughness: 0.26, envMapIntensity: 1.4 }));
    const darkMetal = keep(new T.MeshStandardMaterial({ color: '#383a31', metalness: 0.7, roughness: 0.32, envMapIntensity: 1.2 }));
    const tagMetal = keep(new T.MeshStandardMaterial({ color: '#d2c28e', metalness: 0.72, roughness: 0.38, envMapIntensity: 1.0 }));

    const RX = 1.29, RZ = 1.01, HEIGHT = 0.59, THICK = 0.083;
    function bandGeometry(start, end) {
      const positions = [], uvs = [], indices = [], groups = [];
      const count = Math.ceil((end - start) / (Math.PI * 2) * 160);
      const surfaces = [
        { r: 0, a: -HEIGHT / 2, b: HEIGHT / 2, mat: 0 },
        { r: -THICK, a: HEIGHT / 2, b: -HEIGHT / 2, mat: 1 },
        { y: HEIGHT / 2, a: 0, b: -THICK, mat: 2 },
        { y: -HEIGHT / 2, a: -THICK, b: 0, mat: 2 }
      ];
      surfaces.forEach(surface => {
        const base = positions.length / 3, indexStart = indices.length;
        for (let i = 0; i <= count; i++) {
          const angle = start + (end - start) * i / count;
          for (let j = 0; j < 2; j++) {
            const r = surface.y === undefined ? surface.r : (j ? surface.b : surface.a);
            const y = surface.y === undefined ? (j ? surface.b : surface.a) : surface.y;
            positions.push((RX + r) * Math.cos(angle), y, (RZ + r) * Math.sin(angle));
            uvs.push(angle / (Math.PI * 2), j);
          }
          if (i < count) { const a = base + i * 2; indices.push(a, a + 1, a + 2, a + 2, a + 1, a + 3); }
        }
        groups.push([indexStart, indices.length - indexStart, surface.mat]);
      });
      const g = keep(new T.BufferGeometry());
      g.setAttribute('position', new T.Float32BufferAttribute(positions, 3));
      g.setAttribute('uv', new T.Float32BufferAttribute(uvs, 2));
      g.setIndex(indices); g.computeVertexNormals();
      groups.forEach(group => g.addGroup(...group));
      return g;
    }
    // A continuous band remains visible through the buckle aperture, as on the reference collar.
    const band = new T.Mesh(bandGeometry(0, Math.PI * 2), [cotton, inside, edge]);
    band.castShadow = true; band.receiveShadow = true; collar.add(band);

    const stitchGeometry = keep(new T.BoxGeometry(0.027, 0.010, 0.009));
    const stitches = new T.InstancedMesh(stitchGeometry, thread, 360);
    const transform = new T.Object3D();
    for (let row = 0; row < 2; row++) for (let i = 0; i < 180; i++) {
      const a = i / 180 * Math.PI * 2;
      transform.position.set((RX + 0.006) * Math.cos(a), row ? 0.247 : -0.247, (RZ + 0.006) * Math.sin(a));
      transform.rotation.set(0, Math.atan2(-RZ * Math.cos(a), -RX * Math.sin(a)), 0);
      transform.updateMatrix(); stitches.setMatrixAt(row * 180 + i, transform.matrix);
    }
    stitches.instanceMatrix.needsUpdate = true; collar.add(stitches);

    function roundedRect(w, h, radius, hole) {
      const path = hole ? new T.Path() : new T.Shape();
      const x = -w / 2, y = -h / 2, r = radius;
      path.moveTo(x + r, y); path.lineTo(x + w - r, y);
      path.quadraticCurveTo(x + w, y, x + w, y + r);
      path.lineTo(x + w, y + h - r); path.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      path.lineTo(x + r, y + h); path.quadraticCurveTo(x, y + h, x, y + h - r);
      path.lineTo(x, y + r); path.quadraticCurveTo(x, y, x + r, y);
      return path;
    }
    function frame(w, h, r, border, material, depth) {
      const shape = roundedRect(w, h, r);
      shape.holes.push(roundedRect(w - border * 2, h - border * 2, Math.max(0.015, r - border), true));
      const geometry = keep(new T.ExtrudeGeometry(shape, { depth: depth || 0.055, bevelEnabled: true, bevelSegments: 3, steps: 1, bevelSize: 0.014, bevelThickness: 0.014, curveSegments: 12 }));
      geometry.translate(0, 0, -(depth || 0.055) / 2);
      const mesh = new T.Mesh(geometry, material); mesh.castShadow = true; mesh.receiveShadow = true; return mesh;
    }
    function attachAt(angle, outward) {
      const group = new T.Group();
      group.position.set((RX + outward) * Math.cos(angle), 0, (RZ + outward) * Math.sin(angle));
      group.rotation.y = Math.PI / 2 - angle;
      collar.add(group); return group;
    }
    const buckle = attachAt(0.89, 0.052);
    const buckleFrame = frame(0.79, 0.695, 0.105, 0.078, darkMetal, 0.075);
    buckle.add(buckleFrame);
    const bridgeGeo = keep(new T.CylinderGeometry(0.037, 0.037, 0.63, 12));
    const bridge = new T.Mesh(bridgeGeo, metal); bridge.position.set(-0.04, 0, 0.068); bridge.castShadow = true; buckle.add(bridge);
    const tongue = new T.Mesh(keep(new T.CylinderGeometry(0.023, 0.023, 0.35, 10)), metal);
    tongue.rotation.z = Math.PI / 2; tongue.position.set(0.095, 0, 0.077); tongue.castShadow = true; buckle.add(tongue);
    const tip = new T.Mesh(keep(new T.SphereGeometry(0.027, 10, 8)), metal);
    tip.position.set(0.265, 0, 0.077); buckle.add(tip);

    // Keeper loops have rounded raised edges, and a second strap layer beneath them.
    const keeper = attachAt(0.35, 0.045);
    keeper.add(frame(0.19, 0.685, 0.04, 0.042, darkMetal, 0.08));
    const labelHolder = attachAt(2.25, 0.030);
    const labelShape = roundedRect(0.47, 0.20, 0.025);
    const labelGeometry = keep(new T.ShapeGeometry(labelShape));
    const labelMat = keep(new T.MeshStandardMaterial({ color: '#3A2A16', roughness: 1 }));
    const label = new T.Mesh(labelGeometry, labelMat); label.position.z = 0.023; labelHolder.add(label);
    const labelCanvas = document.createElement('canvas'); labelCanvas.width = 512; labelCanvas.height = 192;
    const lc = labelCanvas.getContext('2d'); lc.clearRect(0, 0, 512, 192); lc.fillStyle = '#F8F5CE';
    lc.font = '900 72px Arial, sans-serif'; lc.textAlign = 'center'; lc.textBaseline = 'middle'; lc.fillText('DOGSHIT', 256, 96);
    const labelTexture = keep(new T.CanvasTexture(labelCanvas)); labelTexture.colorSpace = T.SRGBColorSpace;
    const labelText = new T.Mesh(keep(new T.PlaneGeometry(0.40, 0.15)), keep(new T.MeshStandardMaterial({ map: labelTexture, transparent: true, roughness: 0.9 })));
    labelText.position.z = 0.027; labelHolder.add(labelText);

    const tagAnchor = attachAt(1.72, 0.06);
    const dPath = new T.CurvePath();
    const points = [new T.Vector3(-0.15, 0.02, 0.075), new T.Vector3(0.15, 0.02, 0.075)];
    dPath.add(new T.LineCurve3(points[0], points[1]));
    dPath.add(new T.CubicBezierCurve3(points[1], new T.Vector3(0.28, -0.38, 0.075), new T.Vector3(-0.28, -0.38, 0.075), points[0]));
    const dRing = new T.Mesh(keep(new T.TubeGeometry(dPath, 48, 0.024, 10, true)), metal);
    dRing.castShadow = true; tagAnchor.add(dRing);
    const tab = new T.Mesh(keep(new T.BoxGeometry(0.12, 0.24, 0.05)), cotton);
    tab.position.set(0, 0.0, 0.096); tab.castShadow = true; tagAnchor.add(tab);
    const swing = new T.Group(); swing.position.set(0, -0.225, 0.102); tagAnchor.add(swing);
    const link = new T.Mesh(keep(new T.TorusGeometry(0.092, 0.017, 8, 32)), tagMetal);
    link.position.y = -0.047; link.rotation.y = 0.16; swing.add(link);
    const tag = new T.Group(); tag.position.set(0, -0.40, 0.02); swing.add(tag);
    const tagDisc = new T.Mesh(keep(new T.CylinderGeometry(0.31, 0.31, 0.045, 64)), tagMetal);
    tagDisc.rotation.x = Math.PI / 2; tagDisc.castShadow = true; tag.add(tagDisc);
    const rimRing = new T.Mesh(keep(new T.TorusGeometry(0.285, 0.004, 6, 64)), tagMetal);
    rimRing.position.z = 0.026; tag.add(rimRing);
    const tagCanvas = document.createElement('canvas'); tagCanvas.width = tagCanvas.height = 512;
    const tc = tagCanvas.getContext('2d');
    tc.clearRect(0, 0, 512, 512); tc.fillStyle = '#3A2A16'; tc.textAlign = 'center'; tc.textBaseline = 'middle';
    tc.font = '900 62px Arial, sans-serif'; tc.fillText('DOGSHIT', 256, 257);
    tc.font = 'bold 18px Arial, sans-serif'; tc.fillText('GOOD DOG CLUB', 256, 317);
    tc.beginPath(); tc.arc(256, 92, 8, 0, Math.PI * 2); tc.fill();
    tc.beginPath(); tc.arc(256, 170, 5, 0, Math.PI * 2); tc.fill();
    const tagTexture = keep(new T.CanvasTexture(tagCanvas)); tagTexture.colorSpace = T.SRGBColorSpace;
    const tagWriting = new T.Mesh(keep(new T.PlaneGeometry(0.60, 0.60)), keep(new T.MeshStandardMaterial({ map: tagTexture, transparent: true, roughness: 0.85, depthWrite: false })));
    tagWriting.position.z = 0.027; tag.add(tagWriting);

    const ground = new T.Mesh(keep(new T.PlaneGeometry(12, 12)), keep(new T.ShadowMaterial({ color: '#665431', opacity: 0.15 })));
    ground.rotation.x = -Math.PI / 2; ground.position.y = -1.21; ground.receiveShadow = true; scene.add(ground);
    // Soft contact shadow continues to read well on browsers with low-resolution shadow maps.
    const shadowCanvas = document.createElement('canvas'); shadowCanvas.width = shadowCanvas.height = 128;
    const sc = shadowCanvas.getContext('2d'); const sg = sc.createRadialGradient(64, 64, 3, 64, 64, 64);
    sg.addColorStop(0, 'rgba(58,42,22,.18)'); sg.addColorStop(0.5, 'rgba(58,42,22,.075)'); sg.addColorStop(1, 'rgba(58,42,22,0)');
    sc.fillStyle = sg; sc.fillRect(0, 0, 128, 128);
    const shadowTexture = keep(new T.CanvasTexture(shadowCanvas));
    const softShadow = new T.Mesh(keep(new T.PlaneGeometry(4.4, 3.1)), keep(new T.MeshBasicMaterial({ map: shadowTexture, transparent: true, depthWrite: false, opacity: 0.68 })));
    softShadow.rotation.x = -Math.PI / 2; softShadow.position.y = -1.205; scene.add(softShadow);

    let disposed = false, contextLost = false, raf = 0, inView = true, lastTime = 0, idleTime = 0;
    let yaw = -0.21, targetYaw = yaw, pitch = 0.09, targetPitch = pitch;
    let pointer = null, pointerX = 0, pointerY = 0, pointerStartX = 0, pointerStartY = 0, dragging = false;
    let lastInteraction = -10000, selected = 'olive';
    const targetColor = new T.Color(PALETTE.olive), innerTarget = targetColor.clone(), stitchTarget = targetColor.clone();
    const cream = new T.Color('#F8F5CE');
    const startYaw = yaw;

    function resize() {
      if (disposed) return;
      const w = Math.max(1, host.clientWidth), h = Math.max(1, host.clientHeight);
      camera.aspect = w / h;
      const distance = camera.aspect < 0.85 ? 6.55 : 5.85;
      camera.position.set(0.37 * distance, 0.37 * distance, 0.90 * distance);
      camera.lookAt(0, -0.16, 0);
      camera.updateProjectionMatrix(); renderer.setSize(w, h, false); requestFrame();
    }
    function color(name) {
      if (!PALETTE[name]) return;
      selected = name; host.dataset.color = name; targetColor.set(PALETTE[name]);
      scope.querySelectorAll('[data-3d-color]').forEach(button => {
        const active = button.dataset['3dColor'] === name || button.getAttribute('data-3d-color') === name;
        button.setAttribute('aria-pressed', String(active)); button.classList.toggle('is-active', active);
      });
      host.dispatchEvent(new CustomEvent('dogshit:color', { bubbles: true, detail: { color: name, label: NAMES[name], hex: PALETTE[name] } }));
      setStatus('Obojek ' + NAMES[name] + '. Tažením ho otočíte.');
      lastInteraction = performance.now();
      if (reduced) { cotton.color.copy(targetColor); inside.color.copy(targetColor).multiplyScalar(0.72); edge.color.copy(targetColor).multiplyScalar(0.82); thread.color.copy(targetColor).lerp(cream, 0.35); }
      requestFrame();
    }
    scope.querySelectorAll('[data-3d-color]').forEach(button => on(button, 'click', () => color(button.getAttribute('data-3d-color'))));
    scope.querySelectorAll('[data-3d-reset]').forEach(button => on(button, 'click', () => {
      targetYaw = startYaw; targetPitch = 0.09; lastInteraction = performance.now();
      if (reduced) { yaw = targetYaw; pitch = targetPitch; }
      setStatus('Obojek je zpět v původní poloze.'); requestFrame();
    }));
    on(canvas, 'pointerdown', event => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointer = event.pointerId; pointerX = pointerStartX = event.clientX; pointerY = pointerStartY = event.clientY;
      dragging = event.pointerType === 'mouse'; lastInteraction = performance.now();
      if (dragging) { canvas.setPointerCapture(pointer); canvas.style.cursor = 'grabbing'; }
      requestFrame();
    });
    on(canvas, 'pointermove', event => {
      if (pointer !== event.pointerId) return;
      const dxTotal = event.clientX - pointerStartX, dyTotal = event.clientY - pointerStartY;
      if (!dragging) {
        if (Math.abs(dyTotal) > Math.abs(dxTotal) && Math.abs(dyTotal) > 8) { pointer = null; return; }
        if (Math.abs(dxTotal) < 6) return;
        dragging = true; canvas.setPointerCapture(pointer); canvas.style.cursor = 'grabbing';
      }
      targetYaw += (event.clientX - pointerX) * 0.009;
      if (event.pointerType === 'mouse') targetPitch = clamp(targetPitch + (event.clientY - pointerY) * 0.003, -0.13, 0.4);
      pointerX = event.clientX; pointerY = event.clientY; lastInteraction = performance.now();
      if (reduced) { yaw = targetYaw; pitch = targetPitch; }
      requestFrame();
    });
    function release(event) {
      if (pointer !== event.pointerId) return;
      if (canvas.hasPointerCapture(pointer)) canvas.releasePointerCapture(pointer);
      pointer = null; dragging = false; canvas.style.cursor = 'grab'; lastInteraction = performance.now(); requestFrame();
    }
    on(canvas, 'pointerup', release); on(canvas, 'pointercancel', release);
    on(canvas, 'lostpointercapture', () => { pointer = null; dragging = false; canvas.style.cursor = 'grab'; });
    on(host, 'keydown', event => {
      if (event.target !== host && event.target !== canvas) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home') return;
      event.preventDefault(); targetYaw = event.key === 'Home' ? startYaw : targetYaw + (event.key === 'ArrowRight' ? 0.25 : -0.25);
      lastInteraction = performance.now(); if (reduced) yaw = targetYaw; requestFrame();
    });
    on(canvas, 'webglcontextlost', event => { event.preventDefault(); contextLost = true; host.dataset.state = 'fallback'; setStatus('3D náhled byl pozastaven. Kolekci si můžete prohlédnout níže.'); stopFrame(); });

    function stopFrame() { if (raf) cancelAnimationFrame(raf); raf = 0; lastTime = 0; }
    function requestFrame() { if (!disposed && !contextLost && !raf && inView && !document.hidden) raf = requestAnimationFrame(render); }
    function render(now) {
      raf = 0;
      if (disposed || contextLost || !inView || document.hidden) return;
      const dt = lastTime ? Math.min((now - lastTime) / 1000, 0.04) : 0.016; lastTime = now;
      idleTime += dt;
      const damp = reduced ? 1 : 1 - Math.exp(-dt * 8);
      yaw += (targetYaw - yaw) * damp; pitch += (targetPitch - pitch) * damp;
      cotton.color.lerp(targetColor, reduced ? 1 : 1 - Math.exp(-dt * 7));
      innerTarget.copy(cotton.color).multiplyScalar(0.72); inside.color.copy(innerTarget);
      edge.color.copy(cotton.color).multiplyScalar(0.82);
      stitchTarget.copy(cotton.color).lerp(cream, 0.35); thread.color.copy(stitchTarget);
      const resting = !reduced && !dragging && now - lastInteraction > 1600;
      collar.rotation.set(pitch + (resting ? Math.sin(idleTime * 0.48) * 0.014 : 0), yaw + (resting ? Math.sin(idleTime * 0.25) * 0.035 : 0), -0.105);
      world.position.y = 0.16 + (!reduced ? Math.sin(idleTime * 0.65) * 0.033 : 0);
      swing.rotation.z = reduced ? 0.035 : Math.sin(idleTime * 0.82) * 0.040 + 0.018;
      swing.rotation.x = reduced ? -0.025 : Math.sin(idleTime * 0.70) * 0.023 - 0.025;
      renderer.render(scene, camera);
      const colorDistance = Math.abs(cotton.color.r - targetColor.r) + Math.abs(cotton.color.g - targetColor.g) + Math.abs(cotton.color.b - targetColor.b);
      const moving = Math.abs(targetYaw - yaw) > 0.0003 || Math.abs(targetPitch - pitch) > 0.0003 || colorDistance > 0.001;
      if (!reduced || moving) requestFrame();
    }
    const resizeObserver = new ResizeObserver(resize); resizeObserver.observe(host);
    let intersectionObserver;
    if ('IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        if (inView) requestFrame(); else stopFrame();
      }, { rootMargin: '100px' }); intersectionObserver.observe(host);
    }
    on(document, 'visibilitychange', () => { if (document.hidden) stopFrame(); else requestFrame(); });
    const motionChange = () => { reduced = motionQuery.matches; requestFrame(); };
    if (motionQuery.addEventListener) on(motionQuery, 'change', motionChange);
    else { motionQuery.addListener(motionChange); cleanup.push(() => motionQuery.removeListener(motionChange)); }

    const dispose = () => {
      if (disposed) return;
      disposed = true; stopFrame(); resizeObserver.disconnect(); if (intersectionObserver) intersectionObserver.disconnect();
      cleanup.forEach(fn => fn()); resources.forEach(resource => resource.dispose());
      if (key.shadow.map) key.shadow.map.dispose();
      renderer.dispose(); renderer.forceContextLoss(); canvas.remove(); INSTANCES.delete(host);
    };
    INSTANCES.set(host, dispose);
    host.dataset.state = 'ready'; host.dataset.color = 'olive';
    color('olive'); resize();
  }

  function scan(root) {
    if (root.matches && root.matches('[data-dogshit-3d]')) init(root);
    root.querySelectorAll('[data-dogshit-3d]').forEach(init);
    INSTANCES.forEach((dispose, host) => { if (!host.isConnected) dispose(); });
  }
  window.__dogshit3dRuntime = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => INSTANCES.forEach((dispose, host) => { if (event.target.contains(host)) dispose(); }));
})();

/* Bind the 3D selection to the existing local product demo. */
(() => {
  if (window.__dogshitLanding3D) return;
  window.__dogshitLanding3D = true;
  const labels = {olive:'Olive',sunny:'Sunny',terracotta:'Terracotta',sky:'Sky',cream:'Cream'};
  const positions = {olive:['0%','0%'],sunny:['100%','0%'],terracotta:['0%','50%'],sky:['100%','50%'],cream:['0%','100%']};
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-3d-color]');
    if (!button || !labels[button.dataset.d3Color || button.getAttribute('data-3d-color')]) return;
    const color = button.getAttribute('data-3d-color');
    const scope = button.closest('.hero-3d');
    scope.querySelectorAll('[data-3d-color]').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
    scope.querySelector('[data-3d-select]').dataset.product = color;
    scope.querySelector('[data-3d-color-name]').textContent = labels[color];
    const fallback = scope.querySelector('.scene-fallback');
    if (fallback) { fallback.style.setProperty('--x',positions[color][0]); fallback.style.setProperty('--y',positions[color][1]); }
  });
  let revealObserver;
  function initMotion() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    if (revealObserver) revealObserver.disconnect();
    document.documentElement.classList.add('ds-motion');
    revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}
    }),{threshold:0.06,rootMargin:'0px 0px 40px 0px'});
    document.querySelectorAll('.campaigns,.section-heading,.categories,.story,.journal,.last-word').forEach(item => {
      item.classList.add('ds-reveal');revealObserver.observe(item);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initMotion,{once:true}); else initMotion();
  document.addEventListener('shopify:section:load',initMotion);
})();
